module.exports = __webpack_public_path__ + "static/ellen-armstrong-pic-4-8af1e3081f0a47928ce4a7d2858079f4.jpg";